import * as types from "../types/orderManagement.types";

const initialState = {
  storeIdsFilter: {
    storeIds:[],
    status:[],
    unionStatus:"",
    phone:"",
    order_id:"",
    startDate: "",
    endDate: "",
    currentPage: 1,
    limit: 10,
  },
  taskStatusMarksData: [],
};

const OrderManagementFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_STORE_IDS_FILTER:
      return { ...state, storeIdsFilter: action.payload };
    case types.SET_STATUS_MARK_DATA:
      return { ...state, taskStatusMarksData: action.payload };
    case types.RESET_ORDER_MANAGEMENT_REDUCER:
      return {
        ...state,
        storeIdsFilter: initialState.storeIdsFilter,
        taskStatusMarksData: [],
      };
    default:
      return state;
  }
};
export default OrderManagementFilterReducer;
// OrderManagementFilterReducer